module.exports = __webpack_public_path__ + "img/C05TechRomaInvicta_ua.bac1f6f6.webp";